<template>
    <LayoutDashboard title="Cargos">     
        <v-card outlined>
            <v-card-title>
                <v-btn color="primary" @click="cadastrarCargo" outlined v-if="$helper.verificaPermissao('cadastrar-cargo')">Cadastrar</v-btn>
                <v-spacer></v-spacer>
                <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                </v-text-field>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="getCargos" :search="search" dense>
                    <template v-slot:item.action="{ item }">
                        <v-btn color="primary" outlined small @click="visualizarCargo(item)" v-if="$helper.verificaPermissao('visualizar-cargo')">Visualizar</v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <ModalCadastro />
    </LayoutDashboard>
</template>
<script>
    import {mapActions, mapGetters} from "vuex"
    import ModalCadastro from '@/pages/cargo/ModalCadastro'
    export default { 
        components: {
            ModalCadastro
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: true },
                    { text: 'Nome', align: 'left', sortable: true, value: 'nome'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
            }
        },
        computed: {
            ...mapGetters([
                'getCargos'
            ])
        },
        methods: {
            ...mapActions([
                'listarCargo',
                'cadastrarCargo',
                'visualizarCargo',
            ])
        },
        created(){
            this.listarCargo()
        }
    }
</script>